/* eslint-disable import/no-anonymous-default-export */
export default [
  {
    id: Math.random() * 9,
    imageUrl: "https://source.unsplash.com/UVWJwEroPmo",
    country: "JAPAN",
    mapLink: "https://goo.gl/maps/CmJVY6vUn4igJb598",
    dateVisited: "12 Jan, 2021 - 24 Jan, 2021",
    place: "Mount Fuji",
    description:
      "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
    hasVisited: true,
  },

  {
    id: Math.random() * 9,
    imageUrl: "https://source.unsplash.com/K1bi_VBZHng",
    country: "AUSTRALIA",
    mapLink: "https://goo.gl/maps/t2fMpPCqU2bd2cw66",
    dateVisited: "27 May, 2021 - 8 Jun, 2021",
    place: "Sydney Opera House",
    description:
      "The Sydney Opera House is a multi-venue performing arts centre in Sydney. Located on the banks of the Sydney Harbour, it is often regarded as one of the 20th century's most famous and distinctive buildings",
    hasVisited: false,
  },

  {
    id: Math.random() * 9,
    imageUrl: "https://source.unsplash.com/6ckbKRjydSw",
    country: "NORWAY",
    mapLink: "https://goo.gl/maps/zHSNQo3jzqdQNHY96",
    dateVisited: "01 Oct, 2021 - 18 Nov, 2021",
    place: "Geirangerfjord",
    description:
      "The Geiranger Fjord is a fjord in the Sunnmøre region of Møre og Romsdal county, Norway. It is located entirely in the Stranda Municipality.",
    hasVisited: true,
  },

  {
    id: Math.random() * 9,
    imageUrl: "https://source.unsplash.com/7bBaW4UPk7A",
    country: "PERU",
    mapLink: "https://goo.gl/maps/aaB2BJENDiBhuBAX7",
    dateVisited: "3 July, 2019 - 7 July, 2019",
    place: "Machu Picchu",
    description:
      "Machu Picchu is an Incan citadel set high in the Andes Mountains in Peru. Built in the 15th century and later abandoned, it's renowned for its sophisticated dry-stone walls that fuse huge blocks without the use of mortar, intriguing buildings that play on astronomical alignments and panoramic views. Its exact former use remains a mystery.",
    hasVisited: true,
  },
  {
    id: Math.random() * 9,
    imageUrl: "https://source.unsplash.com/2s1chnvuMQ4",
    country: "CHINA",
    mapLink: "https://goo.gl/maps/3gVUUe5y9gjPYbjb7",
    dateVisited: "19 May, 2018 - 23 May, 2018",
    place: "Great Wall of China",
    description:
      "The Great Wall of China is a series of fortifications made of stone, brick, tamped earth, wood, and other materials, generally built along an east-to-west line across the historical northern borders of China to protect against various nomadic groups from the Eurasian Steppe. It is the longest wall in the world and is considered one of the Seven Wonders of the Medieval World.",
    hasVisited: true,
  },
  {
    id: Math.random() * 9,
    imageUrl: "https://source.unsplash.com/WwuD8D2Xq2k",
    country: "INDIA",
    mapLink: "https://goo.gl/maps/BDmVqTQYms3gTYp18",
    dateVisited: "8 December, 2017 - 12 December, 2017",
    place: "Taj Mahal",
    description:
      "The Taj Mahal is an ivory-white marble mausoleum on the right bank of the Yamuna river in the Indian city of Agra. It was commissioned in 1632 by the Mughal emperor, Shah Jahan, to house the tomb of his favorite wife, Mumtaz Mahal. The Taj Mahal is widely recognized as the jewel of Muslim art in India and one of the universally admired masterpieces of the world's heritage.",
    hasVisited: true,
  },
  {
    id: Math.random() * 9,
    imageUrl: "https://source.unsplash.com/ICXB0_EV0KY",
    country: "USA",
    mapLink: "https://goo.gl/maps/cCA9HRnywVyXxiSz5",
    dateVisited: "20 September, 2016 - 25 September, 2016",
    place: "Grand Canyon",
    description:
      "The Grand Canyon is a steep-sided canyon carved by the Colorado River in Arizona, United States. The Grand Canyon is 277 miles long, up to 18 miles wide and attains a depth of over a mile. It is considered one of the most spectacular natural wonders in the world.",
    hasVisited: true,
  },

  {
    id: Math.random() * 9,
    imageUrl: "https://source.unsplash.com/9f7kwNfXvfU",
    country: "AUSTRALIA",
    mapLink: "https://goo.gl/maps/9BcwubkHUfSN3bih6",
    dateVisited: "2 March, 2022 - 7 March, 2022",
    place: "Uluru",
    description:
      "Uluru, also known as Ayers Rock, is a large sandstone rock formation in the southern part of the Northern Territory in central Australia. It is sacred to the Aboriginal people of the area and is recognized as a UNESCO World Heritage Site. Uluru is famous for its changing colors as the sun sets and rises, making it a popular destination for tourists.",
    hasVisited: true,
  },
];
